const options = {
  // @ts-ignore
  ...window._APP_.sentry,
  attachStacktrace: true,
};

export default options;
